import { Injectable } from '@angular/core';


import { map } from 'rxjs/operators';
import { ToastController } from 'ionic-angular';
// @Injectable({
//   providedIn: 'root'
// })
@Injectable()
export class ServiciosSharedService {

  constructor(private toastController: ToastController) { }
  public labelAttribute: string = "nombre";

  public objects: any[];



  async mostrarMensaje(mensaje) {
    const toast = await this.toastController.create({
      message: mensaje,
      duration: 3000,
      position: 'top',
      cssClass: "my-toast"
    });
    toast.present();
  }
  async mostrarMensajeAbajo(mensaje) {
    const toast = await this.toastController.create({
      message: mensaje,
      duration: 3000,
      position: 'bottom',
      cssClass: "my-toast"
    });
    toast.present();
  }

  async mostrarMensajeError(mensaje) {
    const toast = await this.toastController.create({
      message: mensaje,
      duration: 3000,
      position: 'top',
      cssClass: "my-toastError"
    });
    toast.present();
  }

}




// WEBPACK FOOTER //
// ./src/services/servicios-shared.service.ts